<template lang="pug">
  .offers
    v-container.white.px-4(style="max-width:600px")
      v-card.my-3.mt-2(flat outlined)
        //- Reseller main
        div.py-4.px-6
          v-row(no-gutters align="center")
            v-col
              div.s1.basic800--text {{ $t('commission_title')}}
            v-spacer
            v-col.shrink.d-flex.align-center(v-if="isFetching")
              v-progress-circular.ma-auto(:width="2" :size="20" color="primary" indeterminate)
            v-col.shrink.d-flex.align-center(v-else)
              v-btn(v-if="isNew" x-small color='textColorAccent' depressed height=32 @click="openSetupResellerDialog = true" dark)
                .button-AA-tiny.basic100--text Setup
              y-switch.ma-0(v-else :key="switchKey" v-model="enabled" @change="changeStatus")
          v-row.mt-2(no-gutters)
            div.c1.basic600--text {{ $t('commission_desc')}} 
        v-divider.basic300(v-if="!isNew")
        //- Loading state
        v-layout.py-6(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        //- Listings
        template(v-else)
          div.clickable(v-if="!isNew" v-for="(item, itemIndex) in items" style="cursor: pointer" @click="clickAction(item, itemIndex)")
            div.d-flex.align-center.py-4.px-6
              div.my-auto
                div.s1.basic800--text {{ item.title }}
                  v-chip.c1.white--text.ml-2.px-2(v-if="item.chip" height="18" x-small color="info400") {{ item.chip }}
                div.c1.basic600--text {{ item.description }}
              v-spacer
              eva-icon(name="arrow-ios-forward-outline")
            v-divider.basic300(v-if="itemIndex < items.length - 1")
    .modals
      setup-reseller(v-if="openSetupResellerDialog" :open.sync="openSetupResellerDialog" :step.sync="step" :company="company" :companyTiers.sync="companyTiers" :isNew.sync="isNew" :viaProductTiers="viaProductTiers" :viaMemberTiers="viaMemberTiers")
      reseller-subscription(v-if="openResellerSubscriptionDialog" :open.sync="openResellerSubscriptionDialog" :upgrade="true")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SetupReseller from '@/components/resellers/dialogs/SetupReseller.vue'
import ResellerSubscription from '@/components/resellers/dialogs/ResellerSubscription.vue'

export default {
  name: 'Resellers',
  components: {
    SetupReseller, ResellerSubscription
  },
  data() {
    return {
      isFetching: false,
      companyTiers: [],
      enabled: false,
      isNew: false,
      step: 0,
      switchKey: 0,
      viaProductTiers: false,
      viaMemberTiers: false,
      items: [
        {
          title: this.$t('tier_level'),
          chip: null,
          description: this.$t('set_commission_level'),
          id : 0
        },
        {
          title: this.$t('product_level'),
          chip: null,
          description: this.$t('product_comission'),
          id : 1

        },
        {
          title: this.$t('member_tier'),
          chip: null,
          description: this.$t('reseller_tier_level'), 
          id : 2
        },
        {
          title: this.$t('payout'),
          chip: null,
          description: this.$t('manage_payout'),
          id : 3
        }
      ],
      openSetupResellerDialog: false,
      openResellerSubscriptionDialog: false
    }
  },
  mounted() {
    this.fetchCompanyTiers()
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    fetchUrl() {
      return `/companies/${this.company.id}/tiers`
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    changeStatus(val) {
      // Check auth
      if (val && !this.Auth('component', '/admin/resellers#reseller_settings')) {
        this.openResellerSubscriptionDialog = true
        this.enabled = false
        this.switchKey++
        return
      }
      // Preparing url, data
      const url = `/companies/${this.company.id}/tiers`
      const data = {
        enabled: val,
        tiers: this.companyTiers
      }
      // Post request
      this.axios
        .post(url, data)
        .then(resp => {
          this.enabled = resp.data.enabled
          this.showMessage(['success', `Reseller system ${val ? 'enabled' : 'disabled'}`])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    openDialog(val) {
      this[val] = true
    },
    clickAction(item, itemIndex) {
      // Router push payouts
      if (item.id === 3) {
        this.$router.push('/admin/resellers/payouts')
        return
      }
      // Else
      this.step = itemIndex
      this.viaProductTiers = itemIndex === 1
      this.viaMemberTiers = itemIndex === 2
      this.openSetupResellerDialog = true
    },
    fetchCompanyTiers() {
      this.isFetching = true
      this.axios
        .get(this.fetchUrl)
        .then(resp => {
          this.enabled = resp.data.enabled
          this.companyTiers = [...resp.data.tiers]
          this.isFetching = false
        })
        .catch(error => {
          // Handling no setup error
          if (error.response) {
            const { status } = error.response
            if (status === 404) {
              this.isNew = true
              this.isFetching = false
              return
            }
          }
          // Everything else
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
<i18n>
{
  "en": {
    
      "commission_title" : "Comission",
      "commission_desc" : "Create multi-level commissions to reward your agents or salesperson",
      
      "tier_level": "Tier Level",
      "set_commission_level" :"Set commission level",
      "product_level" : "Product Tier",
      "product_comission":"Set product commission for each tier level",
      "member_tier" : "Members Tier",
      "reseller_tier_level" : "Set tier level for each resellers",
      "payout" :"Payout",
      "manage_payout" : "Manage commission payouts"
       
       
      
    },
  "id": {
    
      "commission_title" : "Komisi",
      "commission_desc" : "Buat komisi multi-level untuk agen atau tim penjualan",
      
      "tier_level": "Tingkat Komisi",
      "set_commission_level" :"Atur level komisi",
      "product_level" : "Tingkat Komisi Produk",
      "product_comission":"Atur komisi bagi setiap produk sesuai tier",
      "member_tier" : "Tingkat Komisi Member",
      "reseller_tier_level" : "Atur tier bagi setiap member",
      "payout" :"Payout",
      "manage_payout" : "Kelola pembayaran komisi"
    
  }
}
</i18n>